module.exports = __webpack_public_path__ + "media/images/user_defined-c5faca49ecfb42dbd55500a474968481.png";